import { AnimatePresence, motion } from 'framer-motion'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { TransitionEl } from '.'
import { useStore } from '../../../lib/context'
import NavModule from '../../__SeasonTwo__/NavModule/NavModule'
import FooterV2 from '../../__SeasonTwo__/Footer/FooterV2'

// const exit = {
//     opacity: 0,
//     transition: {
//         duration:  1000
//     }
// };

// const initial = {
//     opacity: 0
// };

// const enter = {
//     opacity: 1,
//     transition: {
//         duration: 500,
//         delay: 1500
//     }
// };

const variants = {
    initialLoad: {
        opacity: 1,
    },
    initialAfterLoad: {
        opacity: 0,
        y: 8
    },
    exit: {
        opacity: 0,
        transition: {
            duration:  .2,
            delay: .01
        } 
    },
    enter: {
        opacity: 1,
        y: 0,
        transition: {
            duration: .4,
            delay: .02
        },
        easing: "easeOut"
        // transition: {
        //     duration: 500,
        //     delay: 1500
        // }
    }
}

const TransitionPageWrap = observer(({children, location}) => {
    const {transitionStore: {isInitialLoad}} = useStore();
    const key = window && window.location ? window.location.pathname : "init-load";// routePath not working on first link (bug? rehydration issue?)
    const initialState = isInitialLoad ? "initialLoad" : "initialAfterLoad";
    

    return (
        <React.Fragment>
            <AnimatePresence exitBeforeEnter>
                <motion.main
                    key={key + "m-m"}
                    variants={variants}
                    initial={initialState}
                    animate="enter"
                    exit="exit"
                >
                    <motion.div
                        key={key + "m-d"}
                        variants={variants}
                        initial={initialState}
                        animate="enter"
                        exit="exit"
                    >
                        {children}
                    </motion.div>
                </motion.main>
            </AnimatePresence>

            <TransitionEl key="tr-el"/>
            <NavModule key="nav-mod" location={location}/>
            <FooterV2/>
        </React.Fragment>

    )
})

export default TransitionPageWrap